<template>
  <div :class="['row-item cursor-pointer flex items-center', {'disabled-bg': isDisabled}]">
    <div class="flex items-center flex-1">
      <div class="flex flex-wrap">
        <div
          v-for="typeName in Array.from(sampleTypeSet).slice(0,2)"
          :key="typeName"
        >
        <!-- <TestSampleTypeTagNew
          v-if="sampleTypeSet.size <= 1"
          :type="typeName"
        />
        <TestSampleTypeTagNew
          v-else
          :type="getAbbreviation(typeName)"
        /> -->
        </div>
      </div>
      <p :class="['test-name', {'disabled-text': isDisabled}]">
        {{ name }}
      </p>
    </div>
    <div v-if="!isCreateDialog" class="flex items-center ml-3">
      <TestInfoPopover
        :item="test"
        :sample-type-set="sampleTypeSet"
        :name="test.testName"
      />
      <img
        v-if="!isAddOn"
        src="@/assets/orderTest/order-page/custom-panel/favorite_border_24px.svg"
        class="favoriteIcon"
      >
      <SuggestDetailPopover v-else :details="suggestDetails" />
    </div>
  </div>
</template>

<script>
import TestInfoPopover from "../TestInfoPopover.vue";
import TestSampleTypeTagNew from "../TestSampleTypeTagNew.vue";
import SuggestDetailPopover from "../../order-page/order-summary/TestAddOnSuggestion/suggestDetailPopover.vue";
import { processNameAbbreviationNew } from "@/utils/va-order-test/index.js";
import { mapGetters, mapState } from 'vuex';
import { getItemNameByLanguage } from "../../order-page/order-test-panel/order-test-tabs/testCard";

export default {
  components: {
    TestInfoPopover,
    TestSampleTypeTagNew,
    SuggestDetailPopover,
  },
  props: {
    test: {
      type: Object,
      default: null,
    },
    isAddOn: {
      type: Boolean,
      default: false,
    },
    suggestDetails: {
      type: Object,
      default: null,
    },
    isCreateDialog: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(["language"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapState("orderTest/favorites", ["favoriteTestIdList"]),
    ...mapGetters("orderTest/tests", ["testList"]),
    ...mapGetters("orderTest/panels", ["bundleList"]),

    isFavorite() {
      if (this.test.category === "discountPanel")
        return this.favoriteTestIdList
          .find(t => t.itemType === "bundleId" && t.itemId === this.test.bundleId);
      else
        return this.favoriteTestIdList
          .find(t => t.itemType === "packagePriceId" && t.itemId === this.test.id);
    },

    sampleTypeSet() {
      let { blood, nonBlood, dryIce } = this.test.sampleTypeSets;
      return new Set([...blood, ...nonBlood, ...dryIce]);
    },
    name() {
      return this.test.category === "seasonalPromo" ? this.test.discountName : getItemNameByLanguage(this.test, this.language);
    },
  },

  methods: {
    getAbbreviation(name) {
      return processNameAbbreviationNew(name);
    },
  },
};
</script>

<style scoped>
.row-item {
  padding: 8px 8px;
}

.test-name {
  color: #4A4A4A;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.4px;
  line-height: 20px;
}

.favoriteIcon {
  height: 16px;
  width: 16px;
  flex-shrink: 0;
}

.disabled-bg {
  background: #F2F2F2;
}

.disabled-text {
  color: #979797;
}
</style>
